<button *ngIf="visible" mat-icon-button (click)="backToOriginUser()" [disabled]="isLoading">
    <mat-icon *ngIf="!isLoading">arrow_back</mat-icon>
    <mat-progress-spinner *ngIf="isLoading" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
</button>
